<div class="cc-user-panel-container">
    <div class="cc-user-panel-info">
        <div class="cc-user-panel-image-container">
            <i *ngIf="!userInfo?.profileImage" class="fas fa-user-circle"></i>
            <img class="cc-user-panel-image" *ngIf="userInfo?.profileImage" src="{{ userInfo?.profileImage }}" />
        </div>
        <div *ngIf="!isSmallScreen" class="cc-user-panel-name">{{ userInfo?.displayName }}</div>
    </div>
    <dx-context-menu
        *ngIf="menuMode === 'context'"
        [items]="menuItems"
        target=".user-button"
        showEvent="dxclick"
        width="170px"
        [position]="{ my: 'top center', at: 'bottom center' }"
        cssClass="user-menu"
    ></dx-context-menu>
    <dx-list *ngIf="menuMode === 'list'" class="dx-toolbar-menu-action" [items]="menuItems"></dx-list>
</div>
